import axios from "../configs/axios.config";
const SERVER = import.meta.env.VITE_API_URL;

const getBookings = async (page, limit) => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) {
      throw new Error("Authentication token not found. Please login first.");
    }

    const response = await axios.get(
      `${SERVER}/management/bookings?page=${page}&limit=${limit}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching bookings:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

const createNewDispatch = async (data) => {
  // console.log("Data inside createNewDispatch:", data);
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    let response = await axios.post(
      `${SERVER}/api/dispatch/assign-trip`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    // console.log("Response from createNewDispatch:", response);

    return response.data;
  } catch (error) {
    const status = error?.response?.status;
    console.error(
      "Error assigning trip:",
      error.response?.data?.message || error.message,
    );

    if (status === 401 || status === 403) {
      throw new Error("Unauthorized user");
    }

    throw new Error(error.response?.data?.message || "Failed to assign trip");
  }
};

const dispatchTripToAllDrivers = async (data) => {
  try {
    const token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }

    const response = await axios.post(
      `${SERVER}/api/dispatch/dispatch-to-all-drivers`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    if (!response.data?.success) {
      throw new Error(
        response.data?.message || "Dispatch to all drivers was not saved",
      );
    }

    return response.data;
  } catch (error) {
    const status = error?.response?.status;
    const msg =
      error.response?.data?.message ||
      error.message ||
      "Failed to dispatch to all drivers";
    console.error("Error dispatching trip to all drivers:", msg);

    if (status === 401 || status === 403) {
      throw new Error("Unauthorized user");
    }

    throw new Error(msg);
  }
};

const getFleets = async () => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) {
      throw new Error("Authentication token not found. Please login first.");
    }
    const response = await axios.get(`${SERVER}/inventory/fleet/list-all`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching fleets:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

const getDriverFleets = async (vehicleSegmentType) => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) {
      throw new Error("Authentication token not found. Please login first.");
    }

    let url = `${SERVER}/inventory/fleets?ownershipType=driver`;

    if (vehicleSegmentType) {
      url += `&vehicleType=${vehicleSegmentType}`;
    }

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching driver fleets:", error);
    throw new Error(error.response?.data?.message || error.message);
  }
};

export {
  getBookings,
  createNewDispatch,
  dispatchTripToAllDrivers,
  getFleets,
  getDriverFleets,
};
